import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormComponent } from 'src/app/components/form/form.component';
import { MaterialModule } from 'src/app/material.module';
import { CoreService } from 'src/app/services/core.service';
import { PatientService } from 'src/app/services/patient.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-stats',
  standalone: true,
  imports: [CommonModule, MaterialModule, FormComponent],
  templateUrl: './stats.component.html',
  styleUrl: './stats.component.scss'
})
export class StatsComponent implements OnInit {
  formMetadata = {
    name: this.settings.getPortalType() != 'military' ? environment.forms.statsNameCivilian : environment.forms.statsNameMilitary ,
    version: this.settings.getPortalType() != 'military' ? environment.forms.statsVersionCivilian : environment.forms.statsVersionMilitary ,
    submit: false,
  };

  context = {
    language: 'en',
    readonly: false,
    presentationMode: false,
    showAllPages: false,
    dateFormat: 'dd/MM/yyyy',
    theme: 'WHITE',
  };

  formEnvirorment = {
    variables: [
      {
        name: 'ehrId',
        value: '',
      },
    ],
  };

  constructor(private patientService: PatientService, private settings: CoreService) {}

  ngOnInit(): void {
   this.patientService.clearSelectedPatient();
  }
}
